import { render, staticRenderFns } from "./FloatingAnnouncement.vue?vue&type=template&id=34b0ced5&scoped=true"
import script from "./FloatingAnnouncement.vue?vue&type=script&lang=js"
export * from "./FloatingAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./FloatingAnnouncement.vue?vue&type=style&index=0&id=34b0ced5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b0ced5",
  null
  
)

export default component.exports